import type { User, UserId } from "./user";

export const mockUserId = "testUserId" as UserId;
export const mockUser: User = {
  id: mockUserId,
  name: "Test User",
  email: "test@test.com",
};
